import * as LiveUpdates from "@capacitor/live-updates";
import { IonAlert } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { debug } from "../App";

export const CheckForUpdates = (props: any) => {
  const [alertIsOpen, setAlertIsOpen] = useState<boolean>(false);

  const checkForUpdates = async () => {
    try {
      const result = await LiveUpdates.sync();

      debug("CheckForUpdates result", result);

      return result.activeApplicationPathChanged;
    } catch (e: any) {
      debug("CheckForUpdates error", e);
      if (e.message !== "Not implemented for web only") {
        throw e;
      }
    }

    return false;
  };

  useEffect(() => {
    debug("CheckForUpdates.useEffect");

    checkForUpdates().then((hasUpdate: boolean) => {
      setAlertIsOpen(hasUpdate);
    });
  }, []);

  return (
    <>
      <IonAlert
        isOpen={alertIsOpen}
        header={"Update Available"}
        message={"A new update is available. Apply update and reload the app now?"}
        buttons={[
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              setAlertIsOpen(false);
            },
          },
          {
            text: "Apply Update",
            role: "ok",
            handler: async () => {
              await LiveUpdates.reload();
            },
          },
        ]}
      ></IonAlert>
    </>
  );
};
